import { gql } from '@apollo/client';

export const GET_EXPOSURE_TRIPS = gql`
query ExposureTrips($supportedOrganisationId: Int!) {
  exposureTrips(supportedOrganisationId: $supportedOrganisationId) {
    id
    name
    date
    location
    durationDays
    description
  }
}`;
